import { axiosPrivate } from '../../api/connector'

export function getProjects(page: number = 1, search: string = '') {
    return axiosPrivate.get(`/v1/projects/minimal/?page=${page}&search=${search}`)
}
